<template>
  <el-container style="width:100%;" v-loading="fetchLoding">
    <el-header>
      <el-row type="flex" align="middle">
        <el-col style="padding-top: 10px;">
          <el-button round @click="onRefresh">刷新</el-button>
          <el-button round @click="onCreatePlan">增加</el-button>
        </el-col>
      </el-row>
    </el-header>
    <el-main class="planlist">
      <p style="font-size: 14px; color: red;">会员价格方案中，各会员等级对应的数值需设置为大于1小于3的小数或整数。</p>
      <p style="font-size: 14px; color: red;">顾客看到的最终价格 = 成本价 x 折扣值</p>
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" v-for="(plan, index) in plans" :key="plan.id">
          <el-card class="box-card">
            <div slot="header" class="header">
              <el-input
                :disabled="!plan.isEdit"
                placeholder="折扣方案名字"
                size="small"
                style="max-width: 180px; width: 60%;"
                v-model="plan.name"></el-input>
              <div v-if="!plan.isEdit" style="line-height: 30px;">
                <el-button class="header-button" @click="onEdit(index)" type="text">{{ generateCustomizeString('edit') }}</el-button>
                <el-button class="header-button" @click="onDelete(index)" type="text">删除</el-button>
              </div>
              <div v-else style="line-height: 30px;">
                <el-button class="header-button" @click="onSave(index)" type="text">保存</el-button>
                <el-button class="header-button" @click="onCancel(index)" type="text">取消</el-button>
              </div>
            </div>
            <el-table
              :data="plan.level_discounts"
              :default-sort = "{prop: 'level', order: 'descending'}"
              :show-header = "false"
              style="width: 100%; padding-bottom: 10px;">
              <el-table-column
                prop="level"
                label="level"
                width="120">
                <template slot-scope="scope">
                  <el-tag
                    :disable-transitions="true"
                    size="small">
                    {{ scope.row.level_item.name }}
                  </el-tag>
                  <el-tag :disable-transitions="true" type="info" size="small" v-if="scope.row.level === 1">
                    默认
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="discount"
                label="discount">
                <template slot-scope="scope" >
                  <el-input
                    :disabled="!plan.isEdit"
                    placeholder="Please input"
                    size="mini"
                    v-model="scope.row.discount"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
    <el-dialog title="提示" :visible.sync="removePlanDialogVisible" :append-to-body="true">
      <span>确定删除该折扣方案？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="removePlanDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onConfirmDelete()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="创建折扣方案" :visible.sync="createDialogVisiable" :append-to-body="true">
      <el-form ref="form" :model="form" :rules="rules" label-width="40%" class="detailForm">
        <el-form-item label="新建折扣方案" prop="name">
          <el-input v-model="form.name" style="max-width: 320px;"></el-input>
        </el-form-item>
        <div style="margin-top: 50px; text-align: center;">
          <el-button type="primary" @click="onConfirmCreatePlan">立即创建</el-button>
          <el-button @click="onCancelCreate">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'
import { deepCopy, checkNumber } from '@/utils/helper'

export default {
  name: 'DiscountPlanList',
  data() {
    return {
      fetchLoding: false,
      originPlans: [],
      plans: [],
      isEdit: false,
      removePlanDialogVisible: false,
      willDeletePlanId: null,
      createDialogVisiable: false,
      rules: {
        name: [
          {
            required: true,
            min: 2,
            max: 64,
            message: '请输入最少2个字符的角色名',
            trigger: 'blur'
          }
        ]
      },
      form: {
        name: ''
      }
    }
  },
  created() {
    this.fetchAllPlans()
  },
  methods: {
    generateCustomizeString,
    onCreatePlan() {
      this.createDialogVisiable = true
    },
    onConfirmCreatePlan() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.fetchAddPlan(this.form)
        } else {
          this.$message.error({
            message: '数据错误',
            center: true
          })
        }
      })
    },
    onCancelCreate() {
      this.$refs.form.resetFields()
      this.createDialogVisiable = false
    },
    onRefresh() {
      this.fetchAllPlans()
    },
    onEdit(index) {
      this.$set(this.plans[index], `isEdit`, true)
    },
    onCancel(index) {
      this.plans = deepCopy(this.originPlans)
      this.$set(this.plans[index], `isEdit`, false)
    },
    onDelete(index) {
      const plan = this.plans[index]
      this.willDeletePlanId = plan.id
      this.removePlanDialogVisible = true
    },
    onConfirmDelete() {
      if (this.willDeletePlanId) {
        this.fetchDeletePlan(this.willDeletePlanId)
      }
    },
    onSave(index) {
      this.$set(this.plans[index], `isEdit`, false)

      const discountMap = []
      this.originPlans[index].level_discounts.map(levelDiscount => {
        discountMap[levelDiscount.level] = levelDiscount.discount
      })

      const originPlan = this.originPlans[index]
      const plan = this.plans[index]
      const editDiscounts = plan.level_discounts.filter(levelDiscount => {
        const discount = discountMap[levelDiscount.level]
        if (discount === levelDiscount.discount) {
          return false
        }
        return true
      })

      for (var lDiscount of editDiscounts) {
        if (!checkNumber(lDiscount.discount) ||
          lDiscount.discount < 1 || lDiscount.discount > 3) {
          this.$set(this.plans[index], `isEdit`, true)
          this.$message.error({
            message: '折扣输入错误',
            center: true
          })
          return
        }
      }

      if (editDiscounts.length > 0 || originPlan.name !== plan.name) {
        this.fetchUpdatePlan(plan.id, plan.name, editDiscounts.map(levelDiscount => {
          var lDisount = {}
          lDisount.level = levelDiscount.level
          lDisount.discount = levelDiscount.discount
          return lDisount
        }))
      }
    },
    fetchAllPlans() {
      if (this.fetchLoding) return
      this.fetchLoding = true

      request({
        url: 'discount/plan/list',
        method: 'get'
      }).then(response => {
        this.originPlans = response.data.map(plan => {
          plan.isEdit = false
          return plan
        })
        this.plans = deepCopy(this.originPlans)
        this.fetchLoding = false
      }).catch(error => {
        console.warn(error)
        this.fetchLoding = false
      })
    },
    fetchUpdatePlan(planId, name, levelDiscounts) {
      request({
        url: `discount/plan/${planId}`,
        method: 'patch',
        data: {
          'level_discounts': levelDiscounts,
          'name': name || ''
        }
      }).then(response => {
      }).catch(error => {
        console.warn(error)
      })
    },
    fetchDeletePlan(planId) {
      request({
        url: `discount/plan/${planId}`,
        method: 'delete'
      }).then(response => {
        this.willDeletePlanId = null
        this.removePlanDialogVisible = false
        if (response.status === 60020) {
          let goodsStr = ''
          for (var i = response.data.length - 1; i >= 0; i--) {
            goodsStr += response.data[i]['product_name'] + '<br/>'
          }
          this.$alert(goodsStr, response.error, {
            confirmButtonText: '确定',
            dangerouslyUseHTMLString: true
          })
        } else {
          this.fetchAllPlans()
        }
      }).catch(error => {
        console.warn(error)
      })
    },
    fetchAddPlan(data) {
      if (this.createLoading) return
      this.createLoading = true
      request({
        url: 'discount/plan',
        method: 'post',
        data
      }).then(response => {
        this.$refs.form.resetFields()
        this.createDialogVisiable = false
        this.$message.success({
          message: '新建折扣方案成功',
          type: 'success',
          center: true
        })
        this.fetchAllPlans()
        this.createLoading = false
      }).catch(error => {
        console.warn(error)
        this.createLoading = false
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .el-header,
  .el-footer {
    background-color: #f6f6f6;
    color: #333;
  }
  .header-button {
    padding: 0px !important;
  }
  .header {
    display: flex;
    justify-content: space-between;
  }
  .box-card {
    width: 100%;
    margin-bottom: 20px;
    margin-right: 15px;
  }
  .card-list {
    display: flex;
    flex-wrap: wrap;
  }
</style>

<style rel="stylesheet/scss" lang="scss">
  .planlist {
    .el-input__inner{
      color: #666 !important;
    }
    .el-table td, .el-table th {
      padding: 2px 0 !important;
    }
    .el-table td, .el-table th.is-leaf {
      border-bottom: 0px;
    }
    .el-table::before {
      color: unset;
    }
  }
</style>
<style type="text/css">
  .el-dialog {
    width: 40%;
  }
  @media only screen and (max-width: 576px) {
    .el-dialog {
      width: 90%;
    }
  }
</style>
